(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dp24-card-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.DP24CardAtc) return;
    window.DP24CardAtc = true;
    document.addEventListener('click', async (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-dp24-card-atc]') : null;
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const id = Number(btn.dataset.dp24CardAtc);
      const label = btn.querySelector('[data-label]');
      const original = label ? label.textContent : '';
      btn.setAttribute('aria-busy', 'true');
      try {
        if (!window.DP24?.addItems) throw new Error('no helper');
        await window.DP24.addItems([{ id, quantity: 1 }], btn);
        if (label) label.textContent = btn.dataset.added;
        btn.classList.add('is-added');
        setTimeout(() => {
          if (label) label.textContent = original;
          btn.classList.remove('is-added');
        }, 2500);
      } catch (err) {
        const root = window.Shopify?.routes?.root || '/';
        const form = document.createElement('form');
        form.method = 'post';
        form.action = `${root}cart/add`;
        form.innerHTML = `<input type="hidden" name="id" value="${id}"><input type="hidden" name="quantity" value="1">`;
        document.body.appendChild(form);
        form.submit();
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-color-cards"] && !Shopify.designMode) return;
  try {
    class Dp24ColorCards extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-dp24-cc-data]').textContent);
      } catch (e) {
        return;
      }
      this.section = this.closest('.shopify-section') || document.body;
      this.oi = Number(this.dataset.oi);
      const fs = this.fieldset();
      if (!fs) return;

      const picker = fs.closest('variant-picker');
      const visible = picker ? picker.querySelectorAll('fieldset, .variant-option--dropdowns, [data-testid="variant-option-single"]').length : 0;
      this.section.setAttribute('data-dp24-cc-hide', visible <= 1 ? 'all' : fs.dataset.fieldsetIndex || '0');

      this.addEventListener('click', this.onClick);
      this.section.addEventListener('change', this.onChange);
      import('@shopify/events')
        .then(({ StandardEvents }) => {
          this.eventName = StandardEvents.productSelect;
          this.section.addEventListener(this.eventName, this.onProductSelect);
        })
        .catch(() => {});
      this.refresh();
    }

    disconnectedCallback() {
      this.section?.removeAttribute('data-dp24-cc-hide');
      this.section?.removeEventListener('change', this.onChange);
      if (this.eventName) this.section?.removeEventListener(this.eventName, this.onProductSelect);
    }

    picker() {
      return (
        this.section.querySelector('variant-picker[data-template-product-match="true"]') ||
        this.section.querySelector('variant-picker')
      );
    }

    fieldset() {
      const picker = this.picker();
      if (!picker) return null;
      const name = this.dataset.optionName;
      return (
        Array.from(picker.querySelectorAll('fieldset')).find((fs) =>
          fs.querySelector(`input[type="radio"][data-option-name="${CSS.escape(name)}"]`)
        ) || null
      );
    }

    selection() {
      const picker = this.picker();
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('fieldset')).map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    available(value) {
      const sel = this.selection();
      return this.variants.some(
        (v) => v.a && v.o[this.oi] === value && v.o.every((o, i) => i === this.oi || sel[i] == null || sel[i] === o)
      );
    }

    refresh = () => {
      const fs = this.fieldset();
      const checked = fs ? fs.querySelector('input[type="radio"]:checked') : null;
      const current = checked ? checked.value : null;
      this.querySelectorAll('.dp24-cc__card').forEach((card) => {
        const isSel = card.dataset.value === current;
        const ok = this.available(card.dataset.value);
        card.classList.toggle('is-selected', isSel);
        card.setAttribute('aria-checked', isSel ? 'true' : 'false');
        card.classList.toggle('is-unavailable', !ok);
        if (ok) card.removeAttribute('aria-disabled');
        else card.setAttribute('aria-disabled', 'true');
        const so = card.querySelector('[data-dp24-cc-soldout]');
        if (so) so.hidden = ok;
      });
      const label = this.querySelector('[data-dp24-cc-current]');
      if (label && current) label.textContent = current;
    };

    onClick = (e) => {
      const card = e.target.closest('.dp24-cc__card');
      if (!card || card.classList.contains('is-selected') || card.getAttribute('aria-disabled') === 'true') return;
      const fs = this.fieldset();
      const input = fs && Array.from(fs.querySelectorAll('input[type="radio"]')).find((i) => i.value === card.dataset.value);
      if (!input) return;
      // Instant feedback – Horizon then updates price, photos and the add-to-cart button.
      this.querySelectorAll('.dp24-cc__card').forEach((c) => {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-checked', c === card ? 'true' : 'false');
      });
      const label = this.querySelector('[data-dp24-cc-current]');
      if (label) label.textContent = card.dataset.value;
      input.click();
    };

    onChange = (e) => {
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(this.refresh, 0);
    };

    onProductSelect = (e) => {
      if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
      if (e.promise) e.promise.then(() => setTimeout(this.refresh, 30), () => {});
    };
  }

  if (!customElements.get('dp24-color-cards')) {
    customElements.define('dp24-color-cards', Dp24ColorCards);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-delivery-estimate"] && !Shopify.designMode) return;
  try {
    class Dp24DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-dp24-range]');
      const minDays = Number(this.dataset.minDays);
      const maxDays = Number(this.dataset.maxDays);
      const cutoffHour = Number(this.dataset.cutoffHour);
      if (!target || !minDays || maxDays < minDays) return;

      let parts;
      try {
        parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            hourCycle: 'h23',
          })
            .formatToParts(new Date())
            .map(({ type, value }) => [type, value])
        );
      } catch {
        return;
      }

      const start = new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
      if (Number(parts.hour) >= cutoffHour) start.setDate(start.getDate() + 1);

      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const weekday = result.getDay();
          if (weekday !== 0 && weekday !== 6) added += 1;
        }
        return result;
      };

      const format = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      target.textContent = `${format.format(addBusinessDays(start, minDays))} – ${format.format(
        addBusinessDays(start, maxDays)
      )}`;
    }
  }

  if (!customElements.get('dp24-delivery-estimate')) {
    customElements.define('dp24-delivery-estimate', Dp24DeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-photo-check"] && !Shopify.designMode) return;
  try {
    /* Tick → property on the kit line ("Photo Check: Photo Check (+ $5)"), linked to the
     product form via form="" so Horizon's FormData picks it up. */
  (() => {
    const sync = (check) => {
      const host = check.closest('.dp24-pc');
      const section = check.closest('.shopify-section') || document;
      const form = section.querySelector('product-form-component form[id]');
      let input = host.querySelector('input[type="hidden"][data-pc-property]');
      if (!check.checked || !form || !check.dataset.propertyName) {
        input?.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.dataset.pcProperty = '';
        host.appendChild(input);
      }
      input.name = 'properties[' + check.dataset.propertyName + ']';
      input.value = check.dataset.propertyValue || 'Yes';
      // getAttribute: form.id would return the form's <input name="id"> (variant id)
      input.setAttribute('form', form.getAttribute('id'));
    };
    document.addEventListener('change', (e) => {
      if (e.target instanceof HTMLInputElement && e.target.matches('.dp24-pc__check')) sync(e.target);
    });
    /* Re-check right before Horizon reads the form (variant changes re-render the blocks,
       and <dp24-addons>.reset() unticks the box after a successful add) */
    /* window, not document: Horizon's own submit handler is delegated on document (capture) and
       would read the form first */
    window.addEventListener('submit', () => document.querySelectorAll('.dp24-pc__check').forEach((c) => sync(c)), true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-photo-handoff"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.DP24Handoff) return;
    window.DP24Handoff = true;

    const MQ = window.matchMedia ? window.matchMedia('(min-width: 990px) and (hover: hover)') : null;
    let lib = null;

    const variantId = (panel) => {
      const section = panel.closest('.shopify-section') || document;
      const input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      return (input && input.value) || panel.dataset.variant || '';
    };
    const urlFor = (panel) => {
      const id = variantId(panel);
      return panel.dataset.base + '?' + (id ? 'variant=' + encodeURIComponent(id) + '&' : '') + panel.dataset.utm;
    };

    const draw = (panel) => {
      if (!MQ || !MQ.matches || document.documentElement.dataset.dp24Photo === 'ready') return;
      const box = panel.querySelector('[data-dp24-qr]');
      if (!box) return;
      const url = urlFor(panel);
      if (panel.dataset.drawn === url) return;
      lib = lib || import(panel.dataset.lib);
      lib
        .then(({ QRCode }) => {
          if (panel.dataset.drawn === url) return;
          panel.dataset.drawn = url;
          if (panel._qr) {
            panel._qr.clear();
            panel._qr.makeCode(url);
          } else {
            panel._qr = new QRCode(box, { text: url, width: 224, height: 224, alt: '', correctLevel: QRCode.CorrectLevel.M });
          }
          box.removeAttribute('title');
        })
        .catch(() => {
          panel.hidden = true;
        });
    };

    const drawAll = () => document.querySelectorAll('[data-dp24-handoff]').forEach(draw);
    let t = 0;
    const later = () => {
      clearTimeout(t);
      t = setTimeout(drawAll, 400);
    };

    const start = () => {
      drawAll();
      /* Size / shape / frame changes: the code always carries the current variant. Horizon writes
         input[name=id] only after its variant fetch resolves (assets/product-form.js), so redraw when
         that promise settles; the 400 ms timer after 'change' stays as a fallback. */
      document.addEventListener(
        'shopify:product:select',
        (event) => {
          const p = event.promise || (event.detail && event.detail.promise);
          if (p && typeof p.then === 'function') p.then(() => setTimeout(drawAll, 0), () => {});
          else later();
        },
        true
      );
      document.addEventListener('change', later);
      if (MQ && MQ.addEventListener) MQ.addEventListener('change', drawAll);
      document.addEventListener('shopify:section:load', drawAll);
      /* Photo removed again: the panel comes back and needs its code */
      document.addEventListener('dp24:photo-change', drawAll);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-price-savings"] && !Shopify.designMode) return;
  try {
    class Dp24PriceSavings extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      if (!this.section) return;

      import('@shopify/events')
        .then(({ StandardEvents }) => {
          this.eventName = StandardEvents.productSelect;
          this.section.addEventListener(this.eventName, this.handleProductSelect);
        })
        .catch(() => {});
    }

    disconnectedCallback() {
      if (this.section && this.eventName) {
        this.section.removeEventListener(this.eventName, this.handleProductSelect);
      }
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (!event.promise) return;

      event.promise
        .then(({ detail }) => {
          const html = detail?.html;
          if (!html) return;
          const updated = html.querySelector(
            `dp24-price-savings[data-block-id="${this.dataset.blockId}"] [data-dp24-savings-content]`
          );
          const current = this.querySelector('[data-dp24-savings-content]');
          if (updated && current) current.replaceWith(updated);
        })
        .catch(() => {});
    };
  }

  if (!customElements.get('dp24-price-savings')) {
    customElements.define('dp24-price-savings', Dp24PriceSavings);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-upload-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.DP24Photo) return;

    const ICON =
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5"/><path d="M12 3v12"/></svg>';
    const URL_RE = /^https?:\/\/\S+\.(jpe?g|png|heic|heif|webp|gif)(\?|$)|uploadery|theshoppad/i;
    const PREVIEW_RE = /^blob:|^data:image|uploadery|theshoppad|\/uploads?\//i;
    let state = null;
    let blobUrl = '';
    let lastFile = null;

    const guide = () => document.querySelector('.dp24-upload-guide');
    const scope = () => {
      const g = guide();
      return (g && (g.closest('.shopify-section') || g.closest('main'))) || null;
    };
    /* The upload app's file input (Infinite Options or Uploadery) – anywhere in the product section */
    const fileInputs = (root) =>
      [...root.querySelectorAll('input[type="file"]')].filter((i) => !i.closest('dp24-addons, .dp24-frame'));
    /* Hidden/text inputs the app fills with the uploaded file URL – inside the form or linked via form="" */
    const urlInputs = (root) => {
      const list = [...root.querySelectorAll('input[name^="properties"]')];
      document.querySelectorAll('form[action*="/cart/add"] input[name^="properties"]').forEach((i) => list.includes(i) || list.push(i));
      return list.filter((i) => i.type !== 'file' && i.type !== 'checkbox' && i.type !== 'radio' && i.value && URL_RE.test(i.value.trim()));
    };
    const previewImg = (root) =>
      [...root.querySelectorAll('.shopify-app-block img, [class*="uploadery"] img, [class*="infinite"] img, [id*="infinite"] img')].find((img) =>
        PREVIEW_RE.test(img.currentSrc || img.src || '')
      );

    const detect = () => {
      const root = scope();
      if (!root) return { ready: false, thumb: '' };
      const withFile = fileInputs(root).find((i) => i.files && i.files.length > 0);
      if (withFile) {
        const f = withFile.files[0];
        if (f !== lastFile) {
          if (blobUrl) URL.revokeObjectURL(blobUrl);
          blobUrl = /^image\//.test(f.type) ? URL.createObjectURL(f) : '';
          lastFile = f;
        }
        return { ready: true, thumb: blobUrl };
      }
      const stored = urlInputs(root)[0];
      const img = previewImg(root);
      if (stored || img) return { ready: true, thumb: img ? img.currentSrc || img.src : stored.value.trim() };
      return { ready: false, thumb: '' };
    };

    const paint = (s) => {
      document.querySelectorAll('.dp24-upload-cta').forEach((cta) => {
        cta.classList.toggle('is-ready', s.ready);
        const t = cta.querySelector('.dp24-upload-cta__thumb');
        if (t) {
          if (s.ready && s.thumb && /^(blob:|data:image|https?:)/.test(s.thumb)) {
            if (t.getAttribute('src') !== s.thumb) t.src = s.thumb;
            t.hidden = false;
          } else {
            t.hidden = true;
            t.removeAttribute('src');
          }
        }
        setText(cta.querySelector('.dp24-upload-cta__label'), s.ready ? 'Photo uploaded ✓' : 'Upload your photo');
        setText(cta.querySelector('.dp24-upload-cta__help'), helpText(s));
      });
      /* R2: any floating "Upload (your) photo" button outside the upload field (sticky bar, app
         widget) is hidden while a photo is present and comes back when it is removed. */
      document.querySelectorAll('a, button, [role="button"]').forEach((el) => {
        if (el.closest('.dp24-upload-cta, .shopify-app-block, .dp24-upload-guide')) return;
        const marked = el.hasAttribute('data-dp24-stale-upload');
        if (!marked && !(s.ready && UPLOAD_TEXT.test((el.textContent || '').trim()) && isFloating(el))) return;
        if (s.ready && !marked) el.setAttribute('data-dp24-stale-upload', '');
        if (!s.ready && marked) el.removeAttribute('data-dp24-stale-upload');
      });
    };
    const UPLOAD_TEXT = /^upload\s+(your\s+|my\s+|a\s+)?(custom\s+)?photo\b/i;
    const isFloating = (el) => {
      for (let n = el; n && n !== document.body; n = n.parentElement) {
        const pos = getComputedStyle(n).position;
        if (pos === 'fixed' || pos === 'sticky') return true;
      }
      return false;
    };
    const setText = (el, text) => {
      if (el && el.textContent !== text) el.textContent = text;
    };

    /* DP24 2026-10-30: desktop (mouse) gets the drag & drop hint; while a file is dragged over the
       box and after a drop that could not be handed to the app, the line says what to do. */
    const DESKTOP = window.matchMedia ? window.matchMedia('(min-width: 990px) and (hover: hover)') : null;
    let dragging = false;
    let dropFail = 0;
    const helpText = (s) => {
      if (dragging) return 'Drop your photo here';
      if (dropFail > Date.now()) return 'Please click the button to choose your photo';
      if (s.ready) return 'Looks good! Now add your kit to the cart.';
      return DESKTOP && DESKTOP.matches ? 'Click to choose or drag your photo here · JPG or PNG' : 'JPG or PNG · we check every photo';
    };

    const update = () => {
      if (!guide()) return;
      enhance();
      const s = detect();
      paint(s);
      const value = s.ready ? 'ready' : 'missing';
      /* The sticky bar shows "Upload photo" via CSS ::after while no photo is set (dp24-mobile.css);
         give the button the same accessible name, generated content is not reliably announced */
      document.querySelectorAll('.sticky-add-to-cart__button').forEach((b) => {
        if (s.ready) b.removeAttribute('aria-label');
        else if (b.getAttribute('aria-label') !== 'Upload photo') b.setAttribute('aria-label', 'Upload photo');
      });
      if (state !== value) {
        state = value;
        document.documentElement.dataset.dp24Photo = value;
        document.dispatchEvent(new CustomEvent('dp24:photo-change', { detail: { ready: s.ready } }));
      }
    };

    /* R1: one big, accessible button in front of the app's file input */
    let uid = 0;
    const enhance = () => {
      const root = scope();
      if (!root) return;
      fileInputs(root).forEach((input) => {
        if (input.dataset.dp24Cta) return;
        if (!input.id) input.id = 'dp24-photo-input-' + ++uid;
        input.dataset.dp24Cta = '1';
        root.querySelectorAll('label[for="' + CSS.escape(input.id) + '"]').forEach((l) => {
          if (!l.closest('.dp24-upload-cta')) l.classList.add('dp24-upload-hidden-label');
        });

        const cta = document.createElement('div');
        cta.className = 'dp24-upload-cta';
        cta.innerHTML =
          '<button type="button" class="dp24-upload-cta__btn" data-for="' + input.id + '">' +
          ICON +
          '<img class="dp24-upload-cta__thumb" alt="Your photo" width="44" height="44" hidden>' +
          '<span class="dp24-upload-cta__label">Upload your photo</span>' +
          '<span class="dp24-upload-cta__change">Change photo</span>' +
          '</button>' +
          '<p class="dp24-upload-cta__help">' + helpText({ ready: false }) + '</p>';
        /* A real button (not a label with role=button): Enter/Space/click open the file picker */
        cta.querySelector('button').addEventListener('click', () => input.click());
        /* App label wrapping its input: put our button in front of it (no label inside a label) */
        const wrap = input.closest('label');
        if (wrap && !wrap.closest('.dp24-upload-cta')) wrap.classList.add('dp24-upload-hidden-label');
        (wrap || input).insertAdjacentElement('beforebegin', cta);
        input.classList.add('dp24-upload-native');
        input.tabIndex = -1;
        input.addEventListener('focus', () => cta.classList.add('is-focus'));
        input.addEventListener('blur', () => cta.classList.remove('is-focus'));
      });
      /* The app replaced its input (e.g. after "remove"): drop buttons that lost their input */
      document.querySelectorAll('.dp24-upload-cta').forEach((cta) => {
        const id = cta.querySelector('.dp24-upload-cta__btn')?.dataset.for;
        if (!id || !document.getElementById(id)) cta.remove();
      });
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };

    window.DP24Photo = {
      has: () => {
        update();
        return state === 'ready';
      },
      focus: () => document.querySelector('.dp24-upload-cta') || null,
    };

    const start = () => {
      if (!guide()) return;
      update();
      document.addEventListener('change', schedule, true);
      document.addEventListener('input', schedule, true);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'value'] });
      /* Apps set hidden input values from script (no event, no mutation) – cheap safety net */
      setInterval(update, 1000);
      dropSupport();
    };

    /* DP24 2026-10-30: drag & drop. The dashed box looks like a drop zone, but a photo dropped next
       to the tiny native input opened the image in the tab (shopper lost the page + options).
       - Drop on the box (guide tips, app block, our button): the first image goes into the app's own
         file input (input.files) and a bubbling 'change' starts the app's normal upload + checks,
         exactly like choosing the file in the picker. Nothing else of the app is touched.
       - Drop anywhere else on this page: ignored (no navigation away).
       - A drop straight onto a native file input is left to the browser.
       - If the browser refuses the assignment: "Please click the button to choose your photo". */
    const dropSupport = () => {
      const ZONE = '.dp24-upload-guide, .dp24-upload-guide + .shopify-app-block';
      const hasFiles = (e) => !!e.dataTransfer && Array.from(e.dataTransfer.types || []).includes('Files');
      const appBlockOf = (target) => {
        const z = target instanceof Element ? target.closest(ZONE) : null;
        if (!z) return null;
        return z.classList.contains('dp24-upload-guide') ? (z.nextElementSibling?.classList.contains('shopify-app-block') ? z.nextElementSibling : null) : z;
      };
      const isNativeInput = (t) => t instanceof HTMLInputElement && t.type === 'file' && !t.classList.contains('dp24-upload-native');
      let lit = null;
      const light = (block) => {
        if (lit === block) return;
        if (lit) lit.classList.remove('dp24-drop-over');
        lit = block;
        if (lit) lit.classList.add('dp24-drop-over');
        const was = dragging;
        dragging = !!lit;
        if (was !== dragging) schedule();
      };
      const fail = () => {
        dropFail = Date.now() + 8000;
        schedule();
        setTimeout(schedule, 8100);
      };

      document.addEventListener('dragover', (e) => {
        if (!hasFiles(e) || isNativeInput(e.target)) return;
        e.preventDefault();
        const block = appBlockOf(e.target);
        e.dataTransfer.dropEffect = block ? 'copy' : 'none';
        light(block);
      });
      document.addEventListener('dragleave', (e) => {
        if (lit && appBlockOf(e.relatedTarget) !== lit) light(null);
      });
      document.addEventListener('dragend', () => light(null));
      document.addEventListener('drop', (e) => {
        if (!hasFiles(e) || isNativeInput(e.target)) return;
        e.preventDefault();
        light(null);
        const block = appBlockOf(e.target);
        if (!block) return;
        if (block.querySelector('.uploaderyIsUploading')) return;
        const input = fileInputs(block)[0];
        const file = Array.from(e.dataTransfer.files || []).find(
          (f) => /^image\//.test(f.type) || /\.(jpe?g|png|heic|heif|webp)$/i.test(f.name || '')
        );
        if (!input || input.disabled || !file) return fail();
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (err) {
          return fail();
        }
        if (!input.files || input.files.length !== 1) return fail();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', () => update());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dp24-visual-options"] && !Shopify.designMode) return;
  try {
    class Dp24VisualOptions extends HTMLElement {
    connectedCallback() {
      try {
        this.data = JSON.parse(this.querySelector('[data-dp24-vo-data]').textContent);
      } catch (e) {
        return;
      }
      this.section = this.closest('.shopify-section') || document;
      if (!this.picker()) return;

      this.section.classList.add('dp24-vo-active');
      this.stickyDesktop();

      this.addEventListener('click', this.onClick);
      this.section.addEventListener('change', this.onChange);
      /* Preselected variant (see Liquid above): bring Horizon's picker, price and form in line.
         The cards already show it, so refresh() only runs once Horizon has caught up. */
      const pre = this.dataset.preselect && !Dp24VisualOptions.preselected ? this.data.variants.find((v) => String(v.id) === this.dataset.preselect) : null;
      const needsPre = pre && !pre.o.every((o, i) => o === this.selection()[i]);
      if (needsPre) Dp24VisualOptions.preselected = true;

      import('@shopify/events')
        .then(({ StandardEvents }) => {
          this.eventName = StandardEvents.productSelect;
          this.section.addEventListener(this.eventName, this.onProductSelect);
        })
        .catch(() => {})
        .then(() => needsPre && this.selectVariant(pre));
      if (!needsPre) this.refresh();
    }

    disconnectedCallback() {
      this.section?.classList.remove('dp24-vo-active');
      this.section?.removeEventListener('change', this.onChange);
      if (this.eventName) this.section?.removeEventListener(this.eventName, this.onProductSelect);
    }

    picker() {
      return this.section.querySelector('variant-picker[data-template-product-match="true"]') || this.section.querySelector('variant-picker');
    }

    fieldsets() {
      const picker = this.picker();
      return picker ? Array.from(picker.querySelectorAll('fieldset')) : [];
    }

    selection() {
      return this.fieldsets().map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(opts) {
      return this.data.variants.find((v) => opts.every((o, i) => v.o[i] === o)) || null;
    }

    bestVariant(sel) {
      const tokens = String(this.data.best || '')
        .split(',')
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean);
      if (!tokens.length) return null;
      const matches = this.data.variants.filter((v) => {
        const all = v.o.join(' | ').toLowerCase();
        return v.a && tokens.every((t) => all.includes(t));
      });
      if (!matches.length) return null;
      // Prefer the Best Deal that keeps the shopper's other choices (e.g. diamond shape).
      const score = (v) => v.o.reduce((n, o, i) => n + (o === sel[i] ? 1 : 0), 0);
      return matches.sort((x, y) => score(y) - score(x))[0];
    }

    money(cents) {
      const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fmt = this.data.fmt || '';
      return /\{\{\s*amount[a-z_]*\s*\}\}/.test(fmt) ? fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount) : '$' + amount;
    }

    short(value) {
      return String(value).split(' - ')[0].split(' (')[0];
    }

    /* DP24 2026-10-30: desktop sticky bar from page load (see the inline script after the element).
       Re-applied here because a Horizon re-render can reset the attribute to the server value. */
    stickyDesktop() {
      if (!this.hasAttribute('data-dp24-sticky-desktop') || !window.matchMedia) return;
      if (window.matchMedia('(min-width: 990px)').matches && this.dataset.dp24StickyFrom !== 'start') {
        this.dataset.dp24StickyFrom = 'start';
      }
    }

    /* "40x50 cm (15.75x19.69 inch) - Best Deal" → [40, 50]; same parsing as the Liquid above */
    dims(value) {
      const d = String(value).toLowerCase().replace('cm', ' cm').split(' cm')[0].replace('×', 'x').replace(/\s/g, '').split('x').map(Number);
      return d[0] > 0 && d[1] > 0 ? d : null;
    }

    /* DP24 2026-10-30: "★ Best Deal: 67% more canvas than 12 × 16 in for just $7 more" from live data */
    bestNote(sel) {
      const tpl = this.dataset.bestNote;
      const group = this.querySelector('.dp24-vo__group--size');
      if (!tpl || !group) return '';
      const oi = Number(group.dataset.oi);
      const featured = (this.dataset.featured || '').split(',').filter(Boolean);
      const cards = Array.from(group.querySelectorAll('[data-vo-card]'))
        .map((c) => ({ c, t: c.dataset.target, d: this.dims(c.dataset.target) }))
        .filter((x) => x.d);
      const area = (x) => x.d[0] * x.d[1];
      const best = cards.find((x) => x.t.toLowerCase().includes('best'));
      if (!best) return '';
      let small = null;
      cards.forEach((x) => {
        if (area(x) >= area(best) || (featured.length && !featured.includes(x.d.join('x')))) return;
        if (!small || area(x) > area(small)) small = x;
      });
      if (!small) return '';
      const variantFor = (t) => {
        const opts = sel.slice();
        opts[oi] = t;
        return this.findVariant(opts);
      };
      const vb = variantFor(best.t);
      const vs = variantFor(small.t);
      if (!vb || !vs || !vb.a || !vs.a || vb.p <= vs.p) return '';
      const name = small.c.querySelector('.dp24-vo__name');
      return tpl
        .replace('[pct]', String(Math.round((area(best) * 100) / area(small)) - 100))
        .replace('[smaller]', name ? name.textContent.trim() : this.short(small.t))
        .replace('[delta]', this.money(vb.p - vs.p).replace('.00', ''));
    }

    refresh = () => {
      const sel = this.selection();
      if (!sel.length || sel.includes(null)) return;
      this.stickyDesktop();
      const curV = this.findVariant(sel);

      this.querySelectorAll('[data-vo-card]').forEach((card) => {
        const oi = Number(card.dataset.oi);
        const opts = sel.slice();
        opts[oi] = card.dataset.target;
        const v = this.findVariant(opts);
        const isSel = sel[oi] === card.dataset.target;
        card.classList.toggle('is-selected', isSel);
        card.setAttribute('aria-checked', isSel ? 'true' : 'false');
        card.classList.toggle('is-unavailable', !v || !v.a);
        card.setAttribute('aria-disabled', !v || !v.a ? 'true' : 'false');
        if (isSel) card.hidden = false;
        const priceEl = card.querySelector('[data-vo-price]');
        if (priceEl) {
          priceEl.innerHTML = v
            ? (v.a ? '<strong>' + this.money(v.p) + '</strong>' + (v.c > v.p ? ' <s>' + this.money(v.c) + '</s>' : '') : 'Sold out')
            : '';
        }
        /* DP24 2026-10-30: size ladder – "+$7" on bigger sizes only (same shape + frame); smaller sizes show just their price */
        const deltaEl = card.querySelector('[data-vo-delta]');
        if (deltaEl) {
          let html = '';
          if (!isSel && v && v.a && curV && curV.a && v.p > curV.p) {
            const m = this.money(v.p - curV.p).replace('.00', '');
            html =
              '<span aria-hidden="true">+' + m + '</span>' +
              '<span class="visually-hidden">, ' + m + ' more than your current size</span>';
          }
          deltaEl.innerHTML = html;
        }
      });

      const note = this.querySelector('[data-vo-best-note]');
      if (note) {
        const text = this.bestNote(sel);
        if (text && note.textContent !== text) note.textContent = text;
        note.hidden = !text;
      }

      this.querySelectorAll('[data-vo-group]').forEach((g) => {
        const oi = Number(g.dataset.oi);
        const current = g.querySelector('[data-vo-current]');
        const selCard = g.querySelector('[data-vo-card].is-selected .dp24-vo__name');
        if (current) current.textContent = selCard ? selCard.textContent.trim() : this.short(sel[oi]);
      });

      const sum = this.querySelector('[data-vo-sum]');
      const cur = this.findVariant(sel);
      if (sum && cur) {
        sum.hidden = false;
        const names = Array.from(this.querySelectorAll('[data-vo-group]')).map((g) => {
          const n = g.querySelector('[data-vo-card].is-selected .dp24-vo__name');
          if (!n) return '';
          // Size: inches first, cm in brackets – "16 × 20 in (40 × 50 cm)"
          const sub = g.classList.contains('dp24-vo__group--size') ? g.querySelector('[data-vo-card].is-selected .dp24-vo__sub') : null;
          return n.textContent.trim() + (sub && sub.textContent.trim() ? ' (' + sub.textContent.trim() + ')' : '');
        });
        sum.querySelector('[data-vo-sum-text]').textContent = names.filter(Boolean).join(' · ');
        sum.querySelector('[data-vo-sum-price]').textContent = this.money(cur.p);
        const cmp = sum.querySelector('[data-vo-sum-compare]');
        const save = sum.querySelector('[data-vo-sum-save]');
        if (cur.c > cur.p) {
          cmp.hidden = false;
          cmp.textContent = this.money(cur.c);
          save.hidden = false;
          save.textContent = 'You save ' + Math.floor(((cur.c - cur.p) * 100) / cur.c) + '%';
        } else {
          cmp.hidden = true;
          save.hidden = true;
        }
        const best = this.bestVariant(sel);
        const isBest = best && best.id === cur.id;
        sum.classList.toggle('is-best', !!isBest);
        sum.querySelector('[data-vo-sum-deal]').hidden = !isBest;
        const nudge = sum.querySelector('[data-vo-nudge]');
        nudge.hidden = !best || isBest;
        if (best && !isBest) {
          const labels = best.o.map((o, i) => {
            const card = Array.from(this.querySelectorAll('[data-vo-card][data-oi="' + i + '"]')).find((c) => c.dataset.target === o);
            const n = card && card.querySelector('.dp24-vo__name');
            return n ? n.textContent.trim() : this.short(o);
          });
          sum.querySelector('[data-vo-nudge-text]').textContent = labels.join(' · ') + ' – ' + this.money(best.p);
        }
      }
    };

    select(oi, target) {
      const fs = this.fieldsets()[oi];
      if (!fs) return false;
      const input = Array.from(fs.querySelectorAll('input[type="radio"]')).find((i) => i.value === target);
      if (!input || input.checked) return false;
      input.click();
      return true;
    }

    waitForUpdate() {
      return new Promise((resolve) => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          if (this.eventName) this.section.removeEventListener(this.eventName, onEvent);
          setTimeout(resolve, 60);
        };
        const onEvent = (e) => (e.promise ? e.promise.then(finish, finish) : finish());
        if (this.eventName) this.section.addEventListener(this.eventName, onEvent);
        setTimeout(finish, 2500);
      });
    }

    async selectVariant(v) {
      for (let i = 0; i < v.o.length; i++) {
        const wait = this.waitForUpdate();
        if (this.select(i, v.o[i])) await wait;
      }
      this.refresh();
    }

    onClick = (e) => {
      const more = e.target.closest('[data-vo-more]');
      if (more) {
        const group = more.closest('[data-vo-group]');
        const open = more.getAttribute('aria-expanded') !== 'true';
        group.querySelectorAll('[data-vo-extra]').forEach((c) => {
          c.hidden = !open && !c.classList.contains('is-selected');
        });
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.querySelector('[data-vo-more-label]').hidden = open;
        more.querySelector('[data-vo-less-label]').hidden = !open;
        return;
      }
      if (e.target.closest('[data-vo-switch]')) {
        const best = this.bestVariant(this.selection());
        if (best) this.selectVariant(best);
        return;
      }
      const card = e.target.closest('[data-vo-card]');
      if (!card || card.getAttribute('aria-disabled') === 'true' || card.classList.contains('is-selected')) return;
      // Instant feedback, then let Horizon update price, images and the add-to-cart button.
      card.parentElement.querySelectorAll('[data-vo-card]').forEach((c) => {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-checked', c === card ? 'true' : 'false');
      });
      if (this.select(Number(card.dataset.oi), card.dataset.target)) {
        this.waitForUpdate().then(this.refresh);
      }
    };

    onChange = (e) => {
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(this.refresh, 0);
    };

    onProductSelect = (e) => {
      if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
      if (e.promise) e.promise.then(() => setTimeout(this.refresh, 30), () => {});
    };
  }

  if (!customElements.get('dp24-visual-options')) {
    customElements.define('dp24-visual-options', Dp24VisualOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
